import { render, staticRenderFns } from "./ManagementGroupList.vue?vue&type=template&id=43961a65&"
import script from "./ManagementGroupList.vue?vue&type=script&lang=js&"
export * from "./ManagementGroupList.vue?vue&type=script&lang=js&"
import style0 from "./ManagementGroupList.vue?vue&type=style&index=0&id=43961a65&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports